/* 検索結果表示ダイアログ */
import React, { memo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { SearchResult } from '../types/Template';

interface Props {
  is_confirm: boolean;
  details: Array<SearchResult>;
  show: boolean;
  body: string | JSX.Element;
  title: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  ClickCallBackYes: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  ClickCallBackNo: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  ClickCallBackConfirm: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const SearchResultDialog: React.FC<Props> = ({
  is_confirm,
  details,
  show,
  body,
  title,
  handleChange,
  ClickCallBackYes,
  ClickCallBackNo,
  ClickCallBackConfirm,
}) => {
  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={() => {
        return;
      }}
    >
      <Modal.Header>
        <Modal.Title className="dialog-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dialog-body">
        {details.length >= 2 ? (
          <div>
            {details.map((detail, index) => {
              return (
                <label className="radio-label search-result" key={index}>
                  <Form.Check
                    type="radio"
                    value={detail.value}
                    name={detail.form_name}
                    onChange={handleChange}
                    className="radio-button"
                  />
                  {detail.value}
                </label>
              );
            })}
          </div>
        ) : (
          body
        )}
      </Modal.Body>
      <Modal.Footer>
        {is_confirm ? (
          <Button variant="main-color" onClick={ClickCallBackConfirm}>
            確認
          </Button>
        ) : (
          <>
            <Button variant="main-color" onClick={ClickCallBackYes}>
              OK
            </Button>
            <Button variant="main-color" onClick={ClickCallBackNo}>
              キャンセル
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default memo(SearchResultDialog);
